import React from 'react';
import {
  Div,
  withTheme,
} from 'glamorous';
import FaExclamation from 'react-icons/lib/fa/exclamation';

import { alpha } from '../../../styles';

import Title from '../../typography/Title';
import Subtitle from '../../typography/Subtitle';
import Button from '../Button';

class ErrorMessage extends React.PureComponent {
  render() {
    const {
      isReady,
      theme,
      transitionDuration,
    } = this.props;

    return (
      <Div
        display="flex"
        flexDirection="column"
        alignItems="center"
        transition={`opacity ${transitionDuration}ms ease-in-out`}
        opacity={isReady ? 1 : 0}
      >
        <FaExclamation
          size={196}
          color={alpha(theme.danger.base, 0.21)}
        />
        <Title>Oops!</Title>
        <Subtitle marginBottom={32}>Something went wrong.</Subtitle>
        <Button
          navTo="/"
          color="primary"
          label="Back to Home"
        />
      </Div>
    );
  }
}

export default withTheme(ErrorMessage);



// WEBPACK FOOTER //
// ./src/components/ui/ErrorMessage/ErrorMessage.js